(function($) {
  'use strict';

/*
  window.initMap = function() {
    console.log( 'init map' );
    $('.gmap').each( function() { 
      var lat = $(this).data('lat');
      var lng = $(this).data('lng');
      var query = $(this).data('query');
      console.log('query',query);
      var map = new google.maps.Map(this, {
        center: {lat: lat, lng: lng},
        zoom: 8,
     
      });
    });
  };

  $('.gmap-embeds').one('click', function() {
    console.log('click map');
    $('.gmap-embeds iframe').css('pointer-events','auto');    
  });
*/

})(jQuery);

